import React, { useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { Layout } from "antd";
import { any } from "prop-types";

import { AppSider, BreadCrumbRouter } from "../components";
import { getThemeById, ThemeIds, ThemeProvider } from "../contexts";

export const AppContainer = ({
  children,
  style,
  contentPadding = "16px"
}) => {
  const location = useLocation();
  const [themeId, setThemeId] = useState(ThemeIds.Light);
  const [theme, setTheme] = useState(getThemeById(themeId));

  const onChangeTheme = useCallback(
    themeId => {
      setThemeId(themeId);
      setTheme(getThemeById(themeId));
    },
    [setTheme]
  );

  const pagePath = location.pathname;

  return (
    <ThemeProvider value={theme}>
      <Layout style={{ minHeight: "100vh" }}>
        <AppSider
          location={pagePath}
          selectedThemeId={themeId}
          onChangeTheme={onChangeTheme}
        />
        <Layout.Content
          style={{
            // backgroundColor: theme.appBackgroundColor,
            ...style
          }}
        >
          <BreadCrumbRouter />
          <div style={{ padding: contentPadding }}>{children}</div>
        </Layout.Content>
      </Layout>
    </ThemeProvider>
  );
};

AppContainer.propTypes = {
  children: any.isRequired
};
